import { render, staticRenderFns } from "./guide.vue?vue&type=template&id=356b23e5&scoped=true&"
import script from "./guide.vue?vue&type=script&lang=js&"
export * from "./guide.vue?vue&type=script&lang=js&"
import style0 from "./guide.vue?vue&type=style&index=0&id=356b23e5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356b23e5",
  null
  
)

export default component.exports